import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#0070ba",
		d: "M17.35 14.793h-1.051a.15.15 0 0 0-.15.15v1.207h-12.3V3.85H16.15v1.207c0 .082.069.15.15.15h1.052a.15.15 0 0 0 .15-.15V3.1c0-.332-.268-.6-.6-.6H3.1c-.332 0-.6.268-.6.6v13.8c0 .332.268.6.6.6h13.8c.332 0 .6-.268.6-.6v-1.957a.15.15 0 0 0-.15-.15m.363-4.916L14.94 7.689a.156.156 0 0 0-.254.123v1.485H8.556a.157.157 0 0 0-.157.156v1.094c0 .086.07.156.157.156h6.133v1.485c0 .13.152.205.253.122l2.772-2.187a.155.155 0 0 0 .044-.191.2.2 0 0 0-.044-.055"
	})]
});
const ForwardRef = forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
